/**
 * MuiAvatar
 *
 * Demos:
 *
 * - [Avatar](https://ui-packages.isbuildingluma.com/ui-core/react-avatar/)
 *
 * API:
 *
 * - [Avatar API](https://ui-packages.isbuildingluma.com/ui-core/api/avatar/)
 * - inherits [MuiAvatar API](https://mui.com/material-ui/api/avatar/)
 */
const MuiAvatar = {
  styleOverrides: {
    root: {
      fontSize: 16,
      fontWeight: 500
    }
  }
};
export default MuiAvatar;